/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import React from 'react';

import styles from './style/index.module.less';

interface IBackProps {
  visible?: boolean;
  onTap?: () => void;
}

const Back = (props: IBackProps) => {
  const { visible = true, onTap } = props;

  if (!visible) {
    return <div></div>;
  }

  return (
    <div className={styles.back} onClick={onTap}>
      <img className={styles.img} src="https://media-img.puui.qpic.cn/media_img/0/lena/PIC1j88h4_120_64/0" />
    </div>
  );
};

export default React.memo(Back);
